module.exports = __webpack_public_path__ + "static/media/snp.6be8c59e.png";